// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"108":"98e7e9b3","334":"39947780","338":"4e06c10f","501":"226e019b"}[chunkId] + ".chunk.css";
};